import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "background-code",
  "use": "background-code-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"background-code\"><g id=\"background-code_Layer_2\" data-name=\"Layer 2\"><g id=\"background-code_Layer_1-2\" data-name=\"Layer 1\"><path d=\"M20,4V0H0V20H4v4H24V4Zm0,11L18.3,18.54H12A4.61,4.61,0,0,1,7.46,14h0A4.56,4.56,0,0,1,12,9.42H18.3L20,13l.46,1ZM2,18V2H18V4H4V18Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol